import SmarticoPromoModal from './SmarticoPromoModal/SmarticoPromoModal';
import { registerModals } from '@bonanza-social/navigation';
import { ComponentProps, JSXElementConstructor } from 'react';

const modals = {
  SmarticoPromo: SmarticoPromoModal,
};

registerModals('promos', modals);

declare global {
  interface RegisteredModals {
    promos: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
